import { useCallback, useRef, useState } from 'react'
import AccountStorage from 'utils/accounts/AccountStorage'
import { storeKeys } from 'services/store/keys'
import HelperAlerts from 'utils/HelperAlerts'
import i18n from 'utils/i18n'

export default function useAccountSwitch( currentAccountIdentifier = null ) {
	const switching = useRef( false );
	const [ isSwitching, setIsSwitching ] = useState( false );
	const switchAccount = useCallback( async account => {
		if( switching.current || account[ storeKeys.ACCOUNT_IDENTIFIER ] === currentAccountIdentifier ) {
			return;
		}
		switching.current = true;
		setIsSwitching( true );
		try {
			await AccountStorage.switch( account );
		} catch {
			switching.current = false;
			setIsSwitching( false );
			HelperAlerts.alert(
				i18n.t( 'page.authentication.domain.alerts.something_went_wrong.title' ),
				i18n.t( 'page.authentication.domain.alerts.something_went_wrong.message' ),
			);
		}
	}, [ currentAccountIdentifier ] );

	return { isSwitching, switchAccount };
}
